import Api from '@api/hotel/niuniu'
import { isUltimate } from '@merchant-backend/util'
import { isStoreHidden } from '@util'
import { message, Modal } from 'hljd'
import BaseStore from 'hljd/esm/SearchBar/store'
import { action, observable } from 'mobx'
import { hashHistory } from 'react-router'
import {
  EDIT_MEAL_PATH,
  HOTEL_MENU_CREATE_PATH,
  HOTEL_MENU_EDIT_PATH
} from '../constant'

const confirm = Modal.confirm

const SORTER_MAP = {
  'created_at-descend': 1,
  'created_at-ascend': 2,
  'updated_at-descend': 3,
  'updated_at-ascend': 4
}
class Store extends BaseStore {
  @observable keys = '1'
  $listApi = Api.menulist

  constructor(keys = '1') {
    super()
    this.keys = keys
  }

  toLink = () => {
    let msg = isStoreHidden()
    if (msg == 'success') {
      hashHistory.push(HOTEL_MENU_CREATE_PATH)
    } else {
      return message.error(msg)
    }
  }

  onChange = keys => {
    this.keys = keys
    this.$getList(1)
  }

  $getParams = () => {
    this.$list = []
    this.$pagination.total = 0
    this.$pagination.current = 0
    const paramsObj = {
      '1': {
        status: 1,
        is_published: 1
      },
      '2': { status: 0 },
      '3': { status: 2 },
      '4': { is_published: 0 }
    }
    const { field, order } = this.$sorter || {}
    let sortKey = null
    if (field && order) {
      sortKey = field + '-' + order
    }
    return {
      ...paramsObj[String(this.keys)],
      sort: sortKey ? SORTER_MAP[sortKey] : null
    }
  }

  // 判断酒店菜单是否绑定了套餐
  @action
  mealCheckByMenulId = async id => {
    const { success, data = {} } = await Api.mealCheckByMenulId({ id })
    if (success) {
      return data.mealId
    }
  }

  // 下架或删除前处理
  prefixTakeOfOrDelete = async (id, operation) => {
    const mealId = await this.mealCheckByMenulId(id)
    if (mealId) {
      return confirm({
        title: `您设置的套餐中提供了该菜单，无法${operation}，如需${operation}，请先到套餐中修改和该菜单的绑定。`,
        okText: '去修改',
        cancelText: '取消',
        onOk: () => {
          hashHistory.push(`${EDIT_MEAL_PATH}${mealId}`)
        }
      })
    }
  }

  // 上下架菜单
  menufromsale = id => async () => {
    // 已绑定菜单时不能直接下架
    if (this.keys == 1 && isUltimate()) {
      const needBreak = await this.prefixTakeOfOrDelete(id, '下架')
      if (needBreak) return
    }
    let msg = isStoreHidden()
    if (msg == 'success') {
      confirm({
        title: `是否确认${this.keys == 1 ? '下' : '上'}架此菜单?`,
        onOk: async () => {
          let params = {
            id: id,
            btn: this.keys == 1 ? 2 : 1
          }
          const { success, data } = await Api.menufromsale(params)
          if (success) {
            if (this.keys == 1 && typeof data === 'string' && data) {
              message.success(data)
            }
            this.$getList()
          }
        }
      })
    } else {
      return message.error(msg)
    }
  }

  // 删除菜单
  delLive = id => async () => {
    if (isUltimate()) {
      // 已绑定菜单时不能直接删除
      const needBreak = await this.prefixTakeOfOrDelete(id, '删除')
      if (needBreak) return
    }
    confirm({
      title: '是否确认删除此菜单?',
      onOk: async () => {
        let params = {
          id: id,
          btn: 4
        }
        const { success, data } = await Api.menufromsale(params)
        if (success) {
          if (typeof data === 'string' && data) {
            message.success(data)
          }
          this.$getList()
        }
      }
    })
  }

  // 编辑菜单
  edit = id => () => {
    let msg = isStoreHidden()
    if (msg == 'success') {
      hashHistory.push(`${HOTEL_MENU_EDIT_PATH}/${id}`)
    } else {
      return message.error(msg)
    }
  }

  @observable unAuditNumber = 0
  // 获取审核未通过的数量
  getUnAuditNumber = async () => {
    const { success, data } = await Api.getUnAuditNumber(2)
    if (success) {
      this.unAuditNumber = data.pendingCount
    }
  }
}
export default Store
